import { LENDI_BOT_IDENTITY, LendiMemberType } from './types';
export var lendiBot = {
    identity: LENDI_BOT_IDENTITY,
    isOnline: false,
    isTyping: false,
    firstName: 'Lendi',
    lastName: 'Bot',
    type: LendiMemberType.BOT,
    lastConsumedMessageIndex: 0,
};
export var initialState = {
    accessToken: undefined,
    channelId: '',
    identity: undefined,
    recipientIdentity: undefined,
    client: undefined,
    messages: [],
    members: [lendiBot],
    channel: undefined,
    loading: false,
    hasNew: false,
    retryFetch: undefined,
    retryingFetch: false,
    sendMessage: undefined,
    setMessagesRead: undefined,
    error: undefined,
    fetchMore: undefined,
    fetchingMore: false,
    hasMore: true,
    hasCustomerAddedNewMessage: false,
    lendiBotTyping: false,
};
//# sourceMappingURL=index.js.map